<div
  class="wrapper"
  [class.disabled-control]="isEdit && !isEditable"
  [matTooltip]="getStringValue()"
  [matTooltipShowDelay]="1500"
>
  @if (isPossibleToEdit()) {
    <input
      #inputElement
      class="mat-select-input"
      matInput
      (focusin)="handleSelectClick()"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchTermChange($event)"
      (keydown.arrowUp)="onArrowKey($event, 'up')"
      (keydown.arrowDown)="onArrowKey($event, 'down')"
      (keydown.enter)="onEnter($event)"
    >
    <mat-select
      multiple
      #matSelect
      [(ngModel)]="value"
      [required]="required"
      [style.background-color]="getSelectedDataColor()"
      (click)="columnParam.columnProperties.LAZY_SELECT ? handleSelectClick() : null"
      (openedChange)="handleOpenedChange($event)"
      (selectionChange)="handleSelectChange($event)"
      [placeholder]="getPlaceholder()"
    >
      @if (!isEmptyOptions) {
        <mat-checkbox
          [checked]="isAllSelected()"
          (change)="toggleSelectAll()"
        >
          {{ isAllSelected() ? 'Снять все' : 'Выбрать все' }}
        </mat-checkbox>
      }
      @for (option of filteredOptions(); track $index) {
        @if (isOptionShouldBeDisplayed(option)) {
          <mat-option
            [value]="option.id"
            [class.mat-option-select]="option.id === selectedIndex"
            [style.background-color]="getColorWithOpacity(option.color, 0.35)"
            (click)="preventClose($event)"
          >
            {{ option.value }}
          </mat-option>
        }
      }
      @if (isEmptyOptions) {
        <div class="empty-options">
          Нет данных
        </div>
      }
    </mat-select>
  } @else {
    <div class="value-container">
      {{ getStringValue() }}
    </div>
  }
</div>
